import React, { useContext } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import closebtn from '../../assets/img/closebtn.png';
import Logo_final from '../../assets/img/Logo_final.png';
import hamburgermenuImg from '../../assets/img/hamburger-menu.svg';
import chatImg from '../../assets/img/chat.svg';
import adduser from '../../assets/img/adduser.jpg';
import './Header.css';
import { useState, useEffect, useRef } from 'react';
import API from "../../Services/BaseService";
import checkImg from '../../assets/img/check.svg';
import Popup from '../../Component/Popup/Popup';
import warningImg from '../../assets/img/warning.png';
import DealerAction from '../DealerRedux/DealerAction';
import Accept from '../UrCardetails/Accept';
import SealedCounterBid from '../UrCardetails/SealedCounterBid';
import UrCarCounterBid from "../../Container/UrCardetails/UrCarCounterBid";
import SealedBid from '../UrCardetails/SealedBid';
import ls from 'local-storage';
import CommonPopup from '../../Component/CommonPopup/CommonPopup'
import '../../../src/assets/css/responsive.css'
/* import '../../../src/assets/css/style.css' */
import 'bootstrap/dist/js/bootstrap';
import 'material-icons/iconfont/material-icons.css';
import 'material-icons/iconfont/filled.css';
import 'material-icons/iconfont/outlined.css';
import 'material-symbols';
import { Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Loading from "../../Component/Loading/Loading";
import PageNotFound from '../FallBackUI/PageNotFound';
import { CountContext } from '../Context/Allcontext';
import WebSocketCaller from '../WebSocket/WebSocket'
import { Button } from "antd";
import { clearLogin } from '../Login/LoginReducer'

const Header = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
const context = useContext(CountContext);
const { carCount, titleCount, sellerChatList } = context || {};
  const { send, closeWebSocket } = WebSocketCaller();
  console.log(titleCount,"carCount");
const webDataNotification = React.useMemo(() => {
  // Check if sellerChatList exists and is an array
  if (!sellerChatList || !Array.isArray(sellerChatList)) {
    return [];
  }
  
  // Check if sellerChatList has at least one element and it's an array
  if (sellerChatList.length > 0 && Array.isArray(sellerChatList[0])) {
    return sellerChatList[0].filter((item) => item?.notification_status === "notviewed");
  }
  
  // If sellerChatList is directly an array of notification objects
  if (sellerChatList.length > 0 && sellerChatList[0]?.notification_status !== undefined) {
    return sellerChatList.filter((item) => item?.notification_status === "notviewed");
  }
  
  return [];
}, [sellerChatList]);
  const sellerDetails = useSelector(state => state.LoginReducer.payload);
  const dealerData = useSelector(state => state.DealerReducer.payload);
  console.log("==dealerData==", dealerData)
  console.log("==sellerDetails==", sellerDetails)
  const [titledueCount, setTitledueCount] = useState([]);
  const [notificationCount, setNotificationCount] = useState([]);
  const [standingId, setStandingId] = useState("");
  const [buyDealerId, setBuyId] = useState("");
  const [buyerId, setBuyerId] = useState("");
  const [sellerDealersId, setSellerDealersId] = useState("");
  const [carId, setCarId] = useState("");
  const [time, setTime] = useState("");
  const [countBid, setCountBid] = useState(null);
  const [newBid, setNewBid] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [sellitNow, setSellitNow] = useState(null);
  const [highBid, setHighBid] = useState(null);
  
  console.log("setHighBid", highBid);
  const [salesType, setSalesType] = useState(null);
  //chatpopup
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [sellerStandingStatus, setSellerStandingStatus] = useState(sellerDetails);
  // console.log("check the login details",sellerStandingStatus);
  const [sellerColor, setSellerColor] = useState("");

  const loginDetails = ls.get("sellerDetails");
  console.log("check the login details", loginDetails);


  //headernav bar

  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [subMenu, setSubMenu] = useState(false)
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth >= 991);

  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth >= 991);
    };

    // Attach the event listener for window resize
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const [notificationInfo, setNotificationInfo] = useState("");
   // const [isLoading, setIsLoading] = useState(false);
    const [allCarAcceptAllEnable, setAllCarAcceptAllEnable] = useState(false)
    const [allCarMultiAcceptEnable, setAllCarMultiAcceptEnable] = useState(false)
    const [checkedCars, setCheckedCars] = useState([]);
   // const [carId, setCarId] = useState([]);
    const [privilegeDetails, setPrivilegeDetails] = useState("");
    const [isOpen1, setIsOpen1] = useState("");
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const carSelectBox = (id, carData) => {
      const newvalue = document.getElementById(id).checked ? [...checkedCars, carData] : checkedCars.filter(data => data.car_id !== carData.car_id)
      setCheckedCars(document.getElementById(id).checked ? [...checkedCars, carData] : checkedCars.filter(data => data.car_id !== carData.car_id))
      // setCheckedCars(carData)
      console.log("---setCheckedCars----", newvalue)

      setCarId(newvalue.map(data => data?.notification_id))

      console.log("====setCarId====", newvalue.map(data => data?.notification_id))
    }

    const allCarSelectBox = (AllcarsData) => {
      console.log("==AllscarData==", AllcarsData)
      const Allnewsvalue = AllcarsData
      console.log("---setAllsCarInfo----", Allnewsvalue)
      setAllCarMultiAcceptEnable(false);
      setAllCarAcceptAllEnable(true)

      setCarId(Allnewsvalue.map(data => data?.notification_id))

      console.log("====setRecentlyAdded--All-- CarId====", Allnewsvalue.map(data => data?.car_id))

    }

    const MultiAcceptDisable = () => {
      setAllCarMultiAcceptEnable(false)
    }
    const AllAcceptDisable = () => {
      setAllCarAcceptAllEnable(false)
    }
    useEffect(() => {

      if (localStorage.getItem("islogedIn") === "true") {

        getStatusById(dealerData);
        privileges(dealerData);
      }
    }, [dealerData]);

      useEffect(() => {

    if (localStorage.getItem("islogedIn") === "true") {

      getNotificationDetails(dealerData);
     }
   }, [dealerData]); 

  useEffect(() => {
  let intervalId;
  
  // Only run interval if logged in AND sellerDetails exists
  if (localStorage.getItem("islogedIn") === "true" && sellerDetails?.seller_id) {
    intervalId = setInterval(() => {
      // Double-check login state before sending
      if (localStorage.getItem("islogedIn") === "true" && sellerDetails?.seller_id) {
        handleWebNotification(dealerData);
      }
    }, 5000);
  }
  
  return () => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  };
}, [dealerData, sellerDetails]); // Add sellerDetails to dependencies


useEffect(() => {
  const isLoggedIn = localStorage.getItem("islogedIn") === "true";
  
  if (!isLoggedIn) {
    setNotificationInfo([]);
    setNotificationCount(0);
    setNotViewed(0);
    setSeenNotifications([]);
  }
}, [localStorage.getItem("islogedIn")]);

    const privileges = (data) => {
      if (!sellerDetails) {
    console.log("No seller details available, skipping privileges");
    return;
  }
      let request = {
        seller_dealer_id: data == undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,
        seller_id: sellerDetails?.seller_id,
        seller_token: sellerDetails?.seller_token
      }
      API.post("sellerPrivileges/condition", request)
        .then((response) => {
          console.log("privilege", response.data.data[0])
          if (response.data.success === true) {
            setPrivilegeDetails(response.data.data[0])
            
            
          }
          else {
            setErrors(response.data.error)
            setErrorFlag(true)
   
          }

        })
        .catch(function (error) {
          if (error.response) {
            setErrors(error.response.data.error)
            setErrorFlag(true)
           
          }
        });
    }
    const getNotificationDetails = (data) => {
      if (!data && !sellerDetails) {
    console.log("No dealer data available, skipping notification fetch");
    return;
  }
      let request = {
        seller_dealer_id: data === undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,
        seller_id: sellerDetails?.seller_id,
        seller_token: sellerDetails?.seller_token,
      }
     if (!request.seller_dealer_id || !request.seller_id) {
    console.log("Missing required seller data, skipping API call");
    return;
  }
      API.post('notificationDetails/condition', request).then(res => {

        if (res.data.success === true) {
          setNotificationInfo(res.data.data);
          setNotificationCount(res.data.data ? res.data.data[0]?.count : "");
          console.log("setNotificationInfo", res.data.data);
          getNotification(dealerData)
          handleWebNotification(dealerData);
          setIsLoading(false)

        }
        else {
          setErrors(res.data.error.name)
          setErrorFlag(true)
          setIsLoading(false)
        }
      }).catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
           setIsLoading(false)
        }
      });
    }

    const getDeleteNotification = (data) => {
      setIsLoading(true)
      let request = {
        notification_id: [data.notification_id],
        seller_id: sellerDetails?.seller_id,
        seller_token: sellerDetails?.seller_token,
        // seller_dealer_id: sellerDetails?.seller_dealer_id,


      }
      console.log("request Delete", request);
      // return
      API.post('singlenotificationdelete/update', request).then(res => {
        // setNotificationCount(res.data.data);
        getNotificationDetails(dealerData)
      })
        .catch(function (error) {
          if (error.response) {
            setErrors(error.response.data.error)
            setErrorFlag(true)
          }
        });
    }
    const getDeleteAllNotification = (data) => {
      let request = {
        // notification_id: [carId],
        seller_dealer_id: data == undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,

        // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: sellerDetails.seller_dealer_id :data ,

        seller_id: sellerDetails?.seller_id,
        seller_token: sellerDetails?.seller_token
      }
      console.log("request Delete", request);
      API.post('delete_notification/update', request).then(res => {
        // setNotificationCount(res.data.data);
        getNotificationDetails(dealerData)
        setAllCarMultiAcceptEnable(false)
        setAllCarAcceptAllEnable(false)
        getNotification(dealerData)
      })
        .catch(function (error) {
          if (error.response) {
            setErrors(error.response.data.error)
            setErrorFlag(true)
          }
        });
    }

    const observer = useRef(null);

    const sendViewedCount = (data) => {

      if (!seenNotifications || seenNotifications.length === 0) {
        return;
      }
      if (!sellerDetails) {
    console.log("No seller details available, skipping sendViewedCount");
    return;
  }
      let request = {
        seller_dealer_id: data === undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,
        seller_id: sellerDetails?.seller_id,
        seller_token: sellerDetails?.seller_token,
        notification_ids: seenNotifications
      }
      API.post("notification_count_update/update", request).then(response => {
        if (response.data.success === true) {

          handleCountNotification();
          //setSeenNotifications("");
        }
        else {
          setErrors(response.data.error.name)
          setErrorFlag(true)
        }
      }).catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)
        }
      });
    };



  const [notViewed,setNotViewed] = useState("");
  const [seenNotifications,setSeenNotifications] = useState([]);
 useEffect(() => {
  if (localStorage.getItem("islogedIn") === "true" && sellerDetails?.seller_id) {
    handleCountNotification(dealerData);
  }
}, [sellerDetails]); 

   useEffect(() => {
    if (seenNotifications.length > 0) {

      sendViewedCount(dealerData);
    }

  }, [seenNotifications]);
 
   const handleCountNotification = (data) => {
    if (!sellerDetails) {
    console.log("No seller details available, skipping notification count");
    return;
  }
     let request = {
      seller_dealer_id: data === undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,
      seller_id: sellerDetails?.seller_id,
      seller_token: sellerDetails?.seller_token,
     }
     if (!request.seller_dealer_id || !request.seller_id) {
    console.log("Missing required seller data for notification count, skipping API call");
    return;
  }
     API.post("notification_count/condition", request).then(response => {
       if (response.data.success === true) {
         console.log("check the notification count seeen",response.data.data);
         setNotViewed(response.data.data.length)
         
       }
       else {
         setErrors(response.data.error.name)
         setErrorFlag(true)
       }
     }).catch(function (error) {
       if (error.response) {
         setErrors(error.response.data.error)
         setErrorFlag(true)
       }
     });
   }

   

   const markAsSeen = (notificationId) => {
    setSeenNotifications((prevSeen) => {
      if (Array.isArray(prevSeen) && !prevSeen.some(notification => notification.notification_id === notificationId)) {
        const updatedSeen = [...prevSeen, { notification_id: notificationId }]; 
        console.log(`Notification ${notificationId} seen`);
        return updatedSeen; 
      } 
      return prevSeen;
    });
  };
  console.log("seenNotifications",seenNotifications);
  const attachObserver = (element) => {
    if (!observer.current) {
      observer.current = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const notificationId = entry.target.dataset.id;
              markAsSeen(notificationId);
            }
          });
        },
        // { threshold: 1.0 } // Adjust the threshold here as needed
      );
    }
  
    if (element && !observer.current?.elements?.includes(element)) {
      observer.current.observe(element);
      // console.log("Element observed:", element);
    }
  
    // Return a cleanup function to disconnect the observer when necessary
    return () => {
      if (observer.current) {
        observer.current.disconnect();
        observer.current = null;
      }
    };
  };
  

  
    const redirectpage = (pathid, seller_dealer_id) => {
      setPopupVisible(false)
      history.push({
        pathname: "/cardetails",
        state: { backURL: "/carlist", id: pathid, sellerDealerId: seller_dealer_id }
      });
      ls.set("backredirection", ["/carList"])
    };
    //sellerid
    const redirectmanageaccountpage = (pathid, seller_dealer_id) => {
      setPopupVisible(false)
      history.push({
        pathname: "/myprofile",
        state: { backURL: "/myprofile", id: pathid, sellerDealerId: seller_dealer_id }
      });
      ls.set("backredirection", ["/carList"])
    };

    //image
    const redirectmanagepage = (pathid, seller_dealer_id) => {
      setPopupVisible(false)
      history.push({
        pathname: "/myprofile/",
        state: { backURL: "/myprofile", id: pathid, sellerDealerId: seller_dealer_id }
      });
      ls.set("backredirection", ["/carList"])
    };

    const redirectRerunpage = (pathid, seller_dealer_id) => {
      setPopupVisible(false)
      history.push({
        pathname: "/reRunEditdetails/",
        state: { backURL: "/carlist", id: pathid, sellerDealerId: seller_dealer_id }
      });
      ls.set("backredirection", ["/carList"])
    };
    const redirectSoldpage = (pathid, seller_dealer_id) => {
      setPopupVisible(false)
      history.push({
        pathname: "/soldcardetails",
        state: { backURL: "/carlist", id: pathid, sellerDealerId: seller_dealer_id }
      });
      ls.set("backredirection", ["/carList"])
    };

    const redirectBillofsale = (pathid, bill_of_sale_id) => {
      setPopupVisible(false)
      console.log("redirectBillofsale", pathid)
      history.push({
        pathname: "/billofsale",
        state: { BillofSale: bill_of_sale_id, CarId: pathid }
      });
      ls.set("backredirection", ["/carList"])
    };
    const togglePopup1 = () => {
      setIsOpen1(!isOpen1);
    }
    const getAddSellerPrivileges = () => {
      togglePopup1()
      setPopupMsg("Seller doesn't have Counter Bid Privilege");
      setPopupActionType("close");
      setPopupActionValue("ok");
    }

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const closeMobileMenu = () => {
    setShowMobileMenu(false);
  };

  const handleContactUs = () => {
    history.push('/contactus');
    setShowMobileMenu(!showMobileMenu);
    setSubMenu(false)
  }


  const handleLogout = () => {
    console.log("Logging out, closing WebSocket..."); 
    
    // First, clear local storage and state
    localStorage.setItem("islogedIn", false);
    
    if (closeWebSocket && typeof closeWebSocket === 'function') {
        closeWebSocket(); // This will send disconnect message and close connection
    }
    
    setTimeout(() => {
        dispatch(clearLogin());
        dispatch(DealerAction.searchrequest(null));
        history.push('/');
        ls.clear();
        dispatch(DealerAction.searchrequest(null));
        setShowMobileMenu(!showMobileMenu);
        setSubMenu(false);
        console.log("Logout complete");
    }, 150);
}
  console.log("isPopupVisible",isPopupVisible );

  const togglePopupN = () => {
    console.log("enterpopup");
    setIsLoading(true);
    setPopupVisible(true);
    getNotificationDetails(dealerData)
    sendViewedCount(dealerData)
  };

  const closePopup = () => {
    setPopupVisible(false);
    // sendViewedCount(dealerData)
    setSeenNotifications([]);
    
  };


  //headernav barend

  const togglePopup = () => {
    setIsOpen(!isOpen);
  }
  const [isOpenAccept, setIsOpensAccept] = useState(false);
  const [transportationCharge, setTransportationCharge] = useState("");



  const togglePopupAccept = (item) => {
    setIsOpensAccept(!isOpenAccept);
    setBuyId(item?.buyer_dealer_id);
    setCarId(item?.car_id);
    setBuyerId(item?.buyer_id)
    setHighBid(item?.high_bid)
    setTransportationCharge(item?.transportation_charge)
  }

  const [isOpenSealedCounterBid, setIsOpenSealedCounterBid] = useState(false);
  const togglePopupSealedCounterBid = (item) => {
    setPopupVisible(false)
    setIsOpenSealedCounterBid(!isOpenSealedCounterBid);
    setCarId(item?.car_id);
    setHighBid(item?.high_bid)
    setSellitNow(item?.max_price);
    setNewBid(item?.counter_bid);
    setTime(item?.time)
  }

  const [isOpenCounter, setIsOpenCounter] = useState(false);
  const togglePopupCounter = (item) => {
    setPopupVisible(false)
    setIsOpenCounter(!isOpenCounter);
    setCarId(item?.car_id);
    setHighBid(item?.high_bid)
    setSellitNow(item?.max_price);
    setNewBid(item?.counter_bid);
    setTime(item?.time)
  }
  const [isOpenCarHistory, setIsOpenCarHistory] = useState(false);

  const togglePopupCarHistory = (item) => {
    setIsOpenCarHistory(!isOpenCarHistory);
    setBuyId(item.buyer_dealer_id);
    setCarId(item?.car_id);
    setBuyerId(item.buyer_id)
    setHighBid(item.high_bid)
    setSellitNow(item?.max_price);
    setSellerDealersId(item.seller_dealer_id)
    setTransportationCharge(item.transportation_charge)
  }


  const handleWebNotification = (data) => {

    const requestPayload = {

      seller_dealer_id: data === undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,
      seller_id: sellerDetails?.seller_id,
      seller_token: sellerDetails?.seller_token,
      model: "notificationDetails"

    }
    send(requestPayload)
  }


  const getStatusById = (data) => {
if (!sellerDetails) {
    console.log("No seller details available, skipping getStatusById");
    return;
  }
    let request = {

      seller_dealer_id: data == undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,
      seller_id: sellerDetails?.seller_id,
      seller_token: sellerDetails?.seller_token,

    }
    
    API.post('getstatusbyid/condition', request).then(response => {

      setIsLoading(false)
      if (response.data.success === true) {

        if (response.data.data[0].standing_seller_status_id === 7 && (location.pathname === "/carlist" || location.pathname === "/carList" || location.pathname === "/urcar")) {
          history.push("/history")
        }
        console.log("check the response of the getstatusbyid/condition", response.data.data);
        ls.set("sellerStandingStatus", response.data.data[0].standing_seller_status_id)
        ls.set("sellerColor", response.data.data[0])
        setSellerStandingStatus(response.data.data[0].standing_seller_status_id);
        // setSellerColor(response.data.data[0])



      }
      else {
        setErrors(response.data.error.name)
        setErrorFlag(true)

      }


    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)

      }
    });
  }

  const getNotification = (data) => {
    let request = {
      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: sellerDetails.seller_dealer_id :data ,
      seller_dealer_id: data == undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,

      seller_id: sellerDetails?.seller_id,
      seller_token: sellerDetails?.seller_token
    }
    API.post('notificationDetails/condition', request).then(res => {
      // setNotificationInfo(res.data.data);

      if (res.data.success === true) {
        setNotificationCount(res.data.data ? res.data.data[0]?.count : "");
        console.log("setNotificationCount", res.data.data ? res.data.data[0]?.count : "");
        //   setHighBid(res.data.data[0]?.high_bid)
        // setSellitNow(res.data.data[0]?.max_price)
        // setCountBid(res.data.data[0]?.car_max_price)
        // setNewBid(res.data.data[0]?.counter_bid)
        // setCarId(res.data.data[0]?.car_id)
        // setBuyId(res.data.data[0]?.buyer_dealer_id)
        // setBuyerId(res.data.data[0]?.high_buyer_id)
        // setSellerDealersId(res.data.data[0]?.seller_dealer_id)
        // setSalesType(res.data.data[0]?.sales_type)

        // setNotificationID(res.data.data)

      }
      else {
        setErrors(res.data.error.name)
        setErrorFlag(true)

      }


    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)

      }
    });
  }

  // useEffect(() => {
  //   getRefresh();
  //  },[]);
  //  useEffect (()=>{
  //   let intervalId;
  //   intervalId = setInterval(() => {
  //     getRefresh();
  //   }, 5000)
  //   return () => clearInterval(intervalId);
  // },[])


  /*  const Submenu = () => {
     return (
       <ul className="nav__submenu" aria-labelledby="navbarDropdown">
 
         <li className={location.pathname === "/urpost" || location.pathname === "/urpostlist" ? "active" : ""} ><a href="JavaScript:void(0)" className={sellerDetails?.standing_id == "8" ? "gray" : ""} onClick={() => { sellerDetails?.standing_id == "8" ? togglePopup() : history.push('/urpostlist'); ls.set("backredirection", ["/carList"]) }} >urpost</a></li>
         <li className={location.pathname === "/history" ? "active" : ""} ><a href="JavaScript:void(0)" onClick={() => { history.push('/history'); ls.set("backredirection", ["/carList"]) }} >History</a></li>
         <li className={location.pathname === "/titledue" ? "active" : ""} ><a href="JavaScript:void(0)" className={sellerDetails?.standing_id == "8" ? "gray" : ""} onClick={() => { sellerDetails?.standing_id == "8" ? togglePopup() : history.push('/titledue'); ls.set("backredirection", ["/carList"]) }} >Title Due
           {titledueCount?.titledue_count == 0 || titledueCount?.titledue_count == "" || titledueCount?.titledue_count == undefined || titledueCount?.titledue_count == null ? "" :
             <span className="countbox">{titledueCount?.titledue_count}</span>}</a></li>
         <li className={location.pathname === "/inactivecar" ? "active" : ""} ><a href="JavaScript:void(0)" className={sellerDetails?.standing_id == "8" ? "gray" : ""} onClick={() => { sellerDetails?.standing_id == "8" ? togglePopup() : history.push('/inactivecar'); ls.set("backredirection", ["/carList"]); ls.set("carStatus", "") }}>Inactive Cars
           {titledueCount?.inactive_count == 0 || titledueCount?.inactive_count == null || titledueCount?.inactive_count == "" || titledueCount?.inactive_count == undefined ? "" :
             <span className="countbox">{titledueCount?.inactive_count}</span>}</a></li>
         <li className="nav__submenu-item">
           <a href="JavaScript:void(0)" className={sellerDetails?.standing_id == "8" ? "gray" : ""} onClick={() => { sellerDetails?.standing_id == "8" ? togglePopup() : history.push('/sellercharges'); ls.set("backredirection", ["/carList"]) }}>Seller Charges</a>
         </li>
         <li className="nav__submenu-item">
           <a href="JavaScript:void(0)" className={sellerDetails?.standing_id == "8" ? "gray" : ""} onClick={() => { sellerDetails?.standing_id == "8" ? togglePopup() : history.push('/sellerpayment'); ls.set("backredirection", ["/carList"]) }}>Seller Payment</a>
         </li>
         <li className="nav__submenu-item">
           <a href="JavaScript:void(0)" className={sellerDetails?.standing_id == "8" ? "gray" : ""} onClick={() => { sellerDetails?.standing_id == "8" ? togglePopup() : history.push('/manageaccount'); ls.set("backredirection", ["/carList"]) }}>Manage Account</a>
         </li>
         <li className="nav__submenu-item">
           <a href="JavaScript:void(0)" className={sellerDetails?.standing_id == "8" ? "gray" : ""} onClick={() => { sellerDetails?.standing_id == "8" ? togglePopup() : history.push('/meetthestaff') }} >Meet the Staff</a>
         </li>
         <li className="nav__submenu-item">
           <a href="JavaScript:void(0)" onClick={() => history.push('/contactus')}>Contact Us</a>
         </li>
         <li className="nav__submenu-item">
           <a href="JavaScript:void(0)" onClick={() => { history.push('/'); localStorage.clear(); dispatch(DealerAction.searchrequest(null)) }}>Logout</a>
         </li>
       </ul>
     )
   } */
   console.log(notificationCount,"notificationCount");
  const Chat = () => {
    
    
    return (


      <div>
       
      </div>


    )

  }

  const logoNavigation = () => {
    if (localStorage.getItem("islogedIn") === "false" || localStorage.getItem("islogedIn") === null) {
      history.push("/")
    }
    else {
      history.push("/carlist")
    }

  }
  const gettitledueLength = (data) => {
    let request = {
      seller_dealer_id: data == undefined || data === null ? sellerDetails.seller_dealer_id : data.seller_dealer_id,

      // seller_dealer_id: data == undefined ?dealerData !== null ? dealerData.seller_dealer_id: sellerDetails.seller_dealer_id :data ,

      seller_id: sellerDetails?.seller_id,
      seller_token: sellerDetails?.seller_token
      // key:10
    }
    console.log("titleDueDetails", request)
    API.post('countDetails/condition', request).then(res => {
      console.log("titleDueDetails response", res.data?.data);
      if (res.data.success === true) {
        setTitledueCount(res.data?.data);
        console.log("car Detail", res.data?.data);

      }
      else {
        setErrors(res.data.error.name)
        setErrorFlag(true)
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.error)
        setErrorFlag(true)
      }
    });
  }
  useEffect(() => {
    if (localStorage.getItem("islogedIn") === "true") {
      gettitledueLength(dealerData);
    }

  }, [dealerData, carCount, titleCount]);

  const handleRedirect = () => {
    const apiUrl = `http://sellerauction.ur2ndlot.com/auction/email=${sellerDetails.email}/password=${sellerDetails.encryptsellerpassword}`;

    console.log("datas", apiUrl, sellerDetails);
    //return window.location.href = apiUrl;
    window.open(apiUrl, '_blank');
  }
  console.log("datas", sellerDetails);



  // clicks outside submenu close
  const handleOutsideClick = (event) => {
    if (!event.target.closest('.submenu')) {
      setSubMenu(false); 
    }
  };

  
  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);

   
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const ClearStack = () => {
    ls.set("currentpageopen1", "")
  }
  const RedirectAuction = () => {
    const apiUrl = `http://sellerauction.ur2ndlot.com`;
    window.open(apiUrl, '_blank');
  };
  return (
    <div>

      <div id="topbar" class="">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-8 col-md-6 col-sm-6 col-4 topLeft">
              <div class="socialIcons">
                <a href="#" class="facebook"><i class="bx bxl-facebook"></i></a>
                <a href="#" class="snapchat"><i class="bx bxl-snapchat"></i></a>
                <a href="#" class="instagram"><i class="bx bxl-instagram"></i></a>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6 col-8 topRight">
              <div class="rightMenu">
                <i class="bx bxl-phone"></i>
                <a href="tel:+17087772277">CALL US: +1(708)777-2277</a>
              </div>
            </div>
          </div>
        </div>
      </div>


      <header className={` ${showMobileMenu ? 'show-mobile-menu' : ''}`}>


        <nav class="navbar">
          <a class="logo"><img src={Logo_final} onClick={logoNavigation} /></a>

          {localStorage.getItem("islogedIn") === "true" ?

            <ul className="menu-links">
              <span id="close-menu-btn" class="material-symbols-outlined" onClick={closeMobileMenu}>close</span>


              <li className={location.pathname === "/" ? "active" : ""}>
                {sellerStandingStatus !== 7 && sellerDetails?.standing_id == "8" ?
                  <a onClick={togglePopup}>Home</a> :
                  <a onClick={() => { history.push('/carlist'); setShowMobileMenu(false); setSubMenu(false); ClearStack() }}>Home</a>}
              </li>
              <li >
                {sellerStandingStatus !== 7 && sellerDetails?.standing_id == "8" ?
                  <a onClick={togglePopup}>Auction</a> :
                  <a onClick={handleRedirect} >Auction</a>}
              </li>

              <li className={location.pathname === "/urcar" ? "active" : ""}>
                {sellerStandingStatus !== 7 && sellerDetails?.standing_id == "8" ?
                  <a onClick={togglePopup}>urcar</a> :
                  <a onClick={() => { history.push('/urcar'); setShowMobileMenu(false); setSubMenu(false); ls.set("backredirection", ["/carList"]); ClearStack() }}>urcar</a>}
              </li>
              <li className={location.pathname === "/fees" ? "active" : ""}>
                {sellerStandingStatus !== 7 && sellerDetails?.standing_id == "8" ?
                  <a onClick={togglePopup}>Fees</a> :
                  <a onClick={() => { history.push('/fees'); setShowMobileMenu(false); setSubMenu(false); ClearStack() }}>Fees</a>}
              </li>



              <li className="countbox">
                {sellerDetails?.standing_id == "8" ?
                  <img alt="Menu" className='popUpdisable' src={chatImg} onClick={togglePopupN} /> :
                  <img alt="Menu" className='popUpdisable' src={chatImg} onClick={() => { togglePopupN(); setShowMobileMenu(false); setSubMenu(false) }} />}
                {/*   {sellerChatList === "" || sellerChatList === 0 || sellerChatList === null || sellerChatList === undefined ? "" :
                  <span className="countbox03">{sellerChatList[2][0].count === 0 ? 0 : sellerChatList[2][0].count}</span>} */}
                {/* {sellerChatList && sellerChatList.length > 2 && sellerChatList[2][0] && sellerChatList[2][0].count !== 0 && (
                  <span className="countbox03">{sellerChatList[2][0].count}</span>
                )} */}

{webDataNotification?.length === 0 ? "" :
<span className="countbox03">
  {/* {notViewed ? notViewed : webDataNotification?.length} */}
  {webDataNotification?.length }
</span>
}

                {/* {sellerDetails?.standing_id == "8" ? "" :
                  <Chat />} */}
              </li>
              {/* <li><a href="JavaScript:void(0)" onClick={()=>{history.push('/');localStorage.clear()}}>Logout</a></li> */}
              {/*  <li className="topRightUser">


                <b className={JSON.parse(localStorage.getItem("sellerColor"))?.color == "pink"
                  ? "tableRowPink  user_name"
                  : JSON.parse(localStorage.getItem("sellerColor"))?.color == "firered"
                    ? "tableRowFireRed  user_name"
                    : JSON.parse(localStorage.getItem("sellerColor"))?.color == "green"
                      ? "tableRowGreenColor user_name"
                      : JSON.parse(localStorage.getItem("sellerColor"))?.color == "darkred"
                        ? "tableRowRed1  user_name"
                        : " user_name"}
                >
                  {JSON.parse(localStorage.getItem("sellerColor"))?.seller_name} ({JSON.parse(localStorage.getItem("sellerColor"))?.seller_id})
                </b>
             


                <img alt="Menu" src={JSON.parse(localStorage.getItem("loginDetails"))?.image || adduser} />
              </li> */}
              <li>
                <div class="submenu">
                  <p class="more">
                    {isWideScreen ? (
                      <a className={subMenu ? "submenu-toggle" : "submenu-toggle collapsed"} data-bs-toggle="collapse" role="button"
                        aria-expanded={subMenu} onClick={() => setSubMenu(!subMenu)}>
                        {isWideScreen ? <img src={hamburgermenuImg} /> : "More "}
                        <span className="material-symbols-outlined">{isWideScreen ? "" : "chevron_right"}</span>
                      </a>
                    ) : (
                      <a class={subMenu ? "submenu-toggle" : "submenu-toggle collapsed"} data-bs-toggle="collapse" role="button"
                        aria-expanded={subMenu} onClick={() => setSubMenu(!subMenu)}>More <span class="material-symbols-outlined">chevron_right</span> </a>
                    )}
                  </p>
                  {subMenu &&
                    <div class="row">
                      <div class="col more-sub">
                        <div class="collapse multi-collapse show" >
                          <div class="card-body">
                            <ul className="nav__submenu">
                              <li className={location.pathname === "/urpost" || location.pathname === "/urpostlist" ? "active" : ""}>
                                {sellerDetails?.standing_id != "8" ?
                                  <a href="JavaScript:void(0)" onClick={() => {
                                    setShowMobileMenu(!showMobileMenu);
                                    setSubMenu(false); history.push('/urpostlist'); ls.set("backredirection", ["/carList"]); ClearStack()
                                  }}>urpost</a> :
                                  <a href="JavaScript:void(0)" onClick={togglePopup}>urpost</a>

                                }
                              </li>

                              <li className={location.pathname === "/history" ? "active" : ""}>
                                {sellerDetails?.standing_id != "8" ?
                                  <a href="JavaScript:void(0)" onClick={() => {
                                    setShowMobileMenu(!showMobileMenu);
                                    setSubMenu(false); history.push('/history'); ls.set("backredirection", ["/carList"]); ClearStack()
                                  }}>History</a> :
                                  <a href="JavaScript:void(0)" onClick={togglePopup}>History</a>

                                }
                              </li>
                              <li className="countbox">
                                {sellerDetails?.standing_id != "8" ?
                                  <a href="JavaScript:void(0)" onClick={() => {
                                    setShowMobileMenu(!showMobileMenu);
                                    setSubMenu(false); history.push('/titledue'); ls.set("backredirection", ["/carList"]); ls.set("carStatus", ""); ClearStack()
                                  }}>Title Due  {titledueCount?.titledue_count == 0 || titledueCount?.titledue_count == "" || titledueCount?.titledue_count == undefined || titledueCount?.titledue_count == null ? "" :
                                    <span className="countbox01">{titledueCount?.titledue_count}</span>}</a> :
                                  <a href="JavaScript:void(0)" onClick={togglePopup}>Title Due</a>

                                }
                              </li>

                              <li className="countbox">
                                {sellerDetails?.standing_id != "8" ?
                                  <a className={sellerDetails?.standing_id == "8" ? "gray" : ""} href="JavaScript:void(0)" onClick={() => {
                                    setShowMobileMenu(!showMobileMenu);
                                    setSubMenu(false); history.push('/inactivecar'); ls.set("backredirection", ["/carList"]); ls.set("carStatus", ""); ClearStack()
                                  }}>Inactive Cars  {titledueCount?.inactive_count == 0 || titledueCount?.inactive_count == null || titledueCount?.inactive_count == "" || titledueCount?.inactive_count == undefined ? "" :
                                    <span className="countbox01">{titledueCount?.inactive_count}</span>}</a> :
                                  <a href="JavaScript:void(0)" onClick={togglePopup}>Inactive Cars</a>

                                }
                              </li>

                              <li>
                                {sellerDetails?.standing_id != "8" ?
                                  <a className={sellerDetails?.standing_id == "8" ? "gray" : ""} href="JavaScript:void(0)" onClick={() => {
                                    setShowMobileMenu(!showMobileMenu);
                                    setSubMenu(false); history.push('/sellercharges'); ls.set("backredirection", ["/carList"], ls.set("currentpageopen", 1)); ClearStack()
                                  }}>Seller Charges</a> :
                                  <a className={sellerDetails?.standing_id == "8" ? "gray" : ""} href="JavaScript:void(0)" onClick={togglePopup}>Seller Charges</a>

                                }
                              </li>

                              <li>
                                {sellerDetails?.standing_id != "8" ?
                                  <a className={sellerDetails?.standing_id == "8" ? "gray" : ""} href="JavaScript:void(0)" onClick={() => {
                                    setShowMobileMenu(!showMobileMenu);
                                    setSubMenu(false); history.push('/sellerpayment'); ls.set("backredirection", ["/carList"], ls.set("currentpageopen", 1)); ClearStack()
                                  }}>Seller Payment</a> :
                                  <a className={sellerDetails?.standing_id == "8" ? "gray" : ""} href="JavaScript:void(0)" onClick={togglePopup}>Seller Payment</a>

                                }
                              </li>

                              <li>
                                {sellerDetails?.standing_id != "8" ?
                                  <a className={sellerDetails?.standing_id == "8" ? "gray" : ""} href="JavaScript:void(0)" onClick={() => {
                                    setShowMobileMenu(!showMobileMenu);
                                    setSubMenu(false); history.push('/manageaccount'); ls.set("backredirection", ["/carList"]); ClearStack()
                                  }}>Manage Account</a> :
                                  <a className={sellerDetails?.standing_id == "8" ? "gray" : ""} href="JavaScript:void(0)" onClick={togglePopup}>Manage Account</a>

                                }
                              </li>
                              <hr></hr>
                              <li>
                                {sellerDetails?.standing_id != "8" ?
                                  <a className={sellerDetails?.standing_id == "8" ? "gray" : ""} href="JavaScript:void(0)" onClick={() => {
                                    setShowMobileMenu(!showMobileMenu);
                                    setSubMenu(false);
                                    history.push('/meetthestaff');
                                    ls.set("backredirection", ["/carList"]); ClearStack()
                                  }}>Meet the Staff</a> :
                                  <a className={sellerDetails?.standing_id == "8" ? "gray" : ""} href="JavaScript:void(0)" onClick={togglePopup}>Meet the Staff</a>

                                }
                              </li>


                              <li className="nav__submenu-item">
                                <a href="JavaScript:void(0)" onClick={handleContactUs}>Contact Us</a>
                              </li>
                              <hr></hr>
                              <li className="nav__submenu-item">
                                <a href="JavaScript:void(0)" onClick={handleLogout}>Logout</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>}
                </div>

              </li>

            </ul> :
            <ul class="menu-links">
              <span id="close-menu-btn" class="material-symbols-outlined" onClick={closeMobileMenu}>close</span>
              <li className={location.pathname === "/" ? "active" : ""}><a onClick={() => { history.push('/'); setShowMobileMenu(false) }} >Home</a></li>
              <li><a onClick={() => { RedirectAuction(); ClearStack() }}>Auction</a></li>

              <li className={location.pathname === "/aboutus" ? "active" : ""} ><a onClick={() => { history.push('/aboutus'); setShowMobileMenu(false) }} >About Us</a></li>
              <li className={location.pathname === "/fees" ? "active" : ""}><a onClick={() => { history.push('/fees'); setShowMobileMenu(false) }} >Fees</a></li>
              <li className={location.pathname === "/contactus" ? "active" : ""}><a onClick={() => { history.push('/contactform'); setShowMobileMenu(false) }} >Contact Us</a></li>
              <li><a onClick={() => { history.push('/login'); setShowMobileMenu(false) }} class="red-btn">Login</a></li>
            </ul>

          }
          <span id="hamburger-btn" class="material-symbols-outlined" onClick={toggleMobileMenu}>menu</span>
        </nav>
        {/*  {(localStorage.getItem("islogedIn") === "false" || localStorage.getItem("islogedIn") === null) && <a href="JavaScript:void(0)" onClick={() => history.push('/login')} className="get-started-btn dealerLogin">Login</a>} */}

        {/* <a  href="JavaScript:void(0)" onClick={()=>history.push('/login')} class="get-started-btn dealerLogin">Login</a> */}

      </header>
      {/* <a href="JavaScript:void(0)" className="get-started-btn dealerLogin"></a> */}


      {isOpen && <Popup
        content={<>
          <div className="popup-box">
            <div id="" className="CommonModels-box">
              <div className="Commonfullformblock col-lg-9">
                <div className="CommonContainer">
                  <div className="CommonModalcontent">
                    <div className="Commonfull-icon">
                      <img alt="" src={warningImg} />
                    </div>
                    <div className="CommonModalbody">
                      <h2 className="title">Alert</h2>

                      <p>Please Contact Ursecondlot Admin for more details</p>
                      {/* <p>{popupMsg}</p> */}
                    </div>

                    <div className="CommonModalfooter ">
                      <button className="cta-btns" onClick={togglePopup} >Close</button>
                      {/* <button className="cta-btns" onClick={togglePopup} >OK</button>  */}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </>}
        handleClose={togglePopup}
      />}

      {isPopupVisible && (
        <Modal show={isPopupVisible} onHide={closePopup} centered>
          <Modal.Header className="notification" >
            <h2 className='noti-heading'>Notification</h2>
          </Modal.Header>

          <Modal.Body>
            {errorFlag === true ? <PageNotFound error={errors} /> :
              <div className='row'>
                {isLoading ? <Loading /> :

                  <div className='col-lg-12 notiBlock' >
                    {notificationInfo.length > 0 ? notificationInfo.map((item,index) =>
                  // {sellerChatList && sellerChatList[0]?.length > 0 ? sellerChatList[0]?.map((item, index) =>
                      <div class="notoficationcontent" key={item.notification_id} data-id={item.notification_id} ref={attachObserver}>
                        <div class="media">
                          <div className='row'>
                            <div className='col-lg-12' >
                              <div className='row'>
                                {item.type === "Updated" || item.type === "Added" || item.type === "Admin Approved" ?
                                  <div class="col-lg-6">
                                    <p className='text-color4 inventory-class' onClick={() => { redirectmanageaccountpage(item.seller_id, item.seller_dealer_id); }}>Seller #: {item.seller_id}</p>
                                  </div>
                                  :
                                  <>
                                    {item.bill_of_sale_id == null && item.carstatus1 == "unsold" ? <>
                                      {
                                        (item.bill_of_sale_id == null && item.carstatus1 == "unsold" && item.type === "Remove") || (item.type == "Car Inactive" && item.carstatus1 == "unsold") ?
                                          <>
                                            <div class="col-lg-6">
                                              <p className='text-color4 inventory-class' onClick={() => { redirectRerunpage(item.carid, item.seller_dealer_id); }}>Inv #: {item.carid}</p>
                                            </div>
                                            <div class="col-lg-6">
                                              <p className='text-color4 inventory-class' onClick={() => { redirectRerunpage(item.carid, item.seller_dealer_id); }}>Vin #: {item.vin_no}</p>
                                            </div>
                                          </> :
                                          <>
                                            <div class="col-lg-6">
                                              <p className={`${item.changed_type == "Car changed" ? "text-color4 inventory-class statuscolor" : "text-color4 inventory-class"}`} onClick={item.changed_type == "Car changed" ? null : () => { redirectpage(item.carid, item.seller_dealer_id); }}>Inv #: {item.carid}</p>
                                            </div>
                                            <div class="col-lg-6">
                                              <p className={`${item.changed_type == "Car changed" ? "text-color4 inventory-class statuscolor" : "text-color4 inventory-class"}`} onClick={item.changed_type == "Car changed" ? null : () => { redirectpage(item.carid, item.seller_dealer_id); }}>Vin #: {item.vin_no}</p>
                                            </div>
                                          </>
                                      }</> :
                                      <>
                                        <div class="col-lg-6">
                                          <p className={`${item.changed_type == "Car changed" ? "text-color4 inventory-class statuscolor" : "text-color4 inventory-class"}`} onClick={item.changed_type == "Car changed" ? null : () => { redirectSoldpage(item.carid, item.seller_dealer_id) }}>Inv #: {item.carid}</p>
                                        </div>
                                        <div class="col-lg-6">
                                          <p className={`${item.changed_type == "Car changed" ? "text-color4 inventory-class statuscolor" : "text-color4 inventory-class"}`} onClick={item.changed_type == "Car changed" ? null : () => { redirectSoldpage(item.carid, item.seller_dealer_id); }}>Vin #: {item.vin_no}</p>
                                        </div>
                                      </>}

                                    {item.bill_of_sale_id !== null ?
                                      <div class="col-lg-6">
                                        <p className={`${item.changed_type == "Car changed" ? "text-color4 inventory-class statuscolor" : "text-color4 inventory-class"}`} onClick={item.changed_type == "Car changed" ? null : () => { redirectBillofsale(item.carid, item.bill_of_sale_id) }}>Bos #: {item.bill_of_sale_id}</p>
                                      </div> :
                                      item.bill_of_sale_id === null && item.type === "Bill Of Sale Unvoid" ?
                                        <div class="col-lg-6">
                                          <p className={`${item.changed_type == "Car changed" ? "text-color4 inventory-class statuscolor" : "text-color4 inventory-class"}`} onClick={item.changed_type == "Car changed" ? null : () => { redirectBillofsale(item.carid, item.Bos_bill_of_sale_id) }}>Bos #: {item.Bos_bill_of_sale_id}</p>
                                        </div>
                                        : ""
                                    }
                                  </>
                                }
                              </div>




                              <div className='row'>
                                {item.type === "Updated" || item.type === "Added" || item.type === "Admin Approved" ?
                                  <>
                                    <div className='col-lg-6 col-md-6 col-sm-6 col-6'>
                                      <div className='noti-img'>
                                        <img class="align-self-start" src={item?.sellerimage == null || item?.sellerimage == "null" || item?.sellerimage == "undefined" || item?.sellerimage == undefined || item?.sellerimage == "" ? adduser : item?.sellerimage} onClick={() => { redirectmanagepage(item.carid, item.seller_dealer_id) }} />
                                      </div>
                                    </div>
                                  </> :
                                  <>
                                    {item.carstatus1 == "unsold" ?
                                      <>{(item.bill_of_sale_id == null && item.carstatus1 == "unsold" && item.type === "Remove") || (item.type == "Car Inactive" && item.carstatus1 == "unsold") ?
                                        <div className='col-lg-6 col-md-6 col-sm-6 col-6'>
                                          <div className='noti-img'>
                                            <img class={`${item.changed_type == "Car changed" ? "align-self-start statuscolor" : "align-self-start"}`} src={item?.image} onClick={item.changed_type == "Car changed" ? null : () => { redirectRerunpage(item.carid, item.seller_dealer_id) }} />
                                          </div>
                                        </div> :
                                        <div className='col-lg-6 col-md-6 col-sm-6 col-6'>
                                          <div className='noti-img'>
                                            <img class={`${item.changed_type == "Car changed" ? "align-self-start statuscolor" : "align-self-start"}`} src={item?.image} onClick={item.changed_type == "Car changed" ? null : () => { redirectpage(item.carid, item.seller_dealer_id) }} />
                                          </div>
                                        </div>
                                      }</> :
                                      <div className='col-lg-6 col-md-6 col-sm-6 col-6'>
                                        <div className='noti-img'>
                                          <img class={`${item.changed_type == "Car changed" ? "align-self-start statuscolor" : "align-self-start"}`} src={item?.image} onClick={item.changed_type == "Car changed" ? null : () => { redirectSoldpage(item.carid, item.seller_dealer_id) }} />
                                        </div>
                                      </div>}
                                  </>}
                                <div className='col-lg-6 col-md-6 col-sm-6 col-6'>
                                  {item.type === "Updated" || item.type === "Added" || item.type === "Admin Approved" ?
                                    <div className='noti-title'>
                                      <p className='text-color' >{item?.sellername}</p>
                                    </div> :
                                    <>
                                      <div className='noti-title'>
                                        <p className='text-color' >{item?.year}</p><p className='text-color1'> {item?.make} </p><p className='text-color2'>{item?.model}</p>
                                      </div>
                                    </>}
                                </div>

                              </div>





                              <div class="media-body">
                                <h5 className='noti-sub-title' >{item?.title}</h5>
                                <p className='text-color3'>{item?.notificationmessage}</p>

                                {item?.type == "New Bid" ?
                                  <div className='acmk'>
                                    {item?.carstatus == "sold" || item?.bid_status == 0 ? "" :
                                      <>
                                        <p className={item.standing_seller_status_id === 6 || item.standing_seller_status_id === 7 || item.changed_type == "Car changed" || item.type == "Car Inactive" ? "accept-bid statuscolor " : "accept-bid"} onClick={item.changed_type == "Car changed" || item.type == "Car Inactive" ? null : () => !(item.standing_seller_status_id === 6 || item.standing_seller_status_id === 7) && (
                                          item?.sales_type == "Make Bid" /* || "Normal Bid" */ ? togglePopupAccept(item) :
                                            togglePopupCarHistory(item)
                                        )}  >Accept</p>&nbsp;
                                      </>}

                                    {item?.carstatus == "sold" || item?.bid_status == 0 ? "" :
                                      <>{privilegeDetails.counter_bid == 0 ?
                                        <p className={item.standing_seller_status_id === 6 || item.standing_seller_status_id === 7 || item.changed_type == "Car changed" || item.type == "Car Inactive" ? "make-bid statuscolor " : "make-bid"} onClick={item.changed_type == "Car changed" || item.type == "Car Inactive" ? null : () => getAddSellerPrivileges()} >
                                          {item.time == 0 || item.time === null ? "Counter Bid" : "Update Counter Bid"} </p> :
                                        <p className={item.standing_seller_status_id === 6 || item.standing_seller_status_id === 7 || item.changed_type == "Car changed" || item.type == "Car Inactive" ? "make-bid statuscolor " : "make-bid"} onClick={item.changed_type == "Car changed" || item.type == "Car Inactive" ? null : () => !(item.standing_seller_status_id === 6 || item.standing_seller_status_id === 7) && (
                                          item?.sales_type == "Make Bid"/*  || "Normal Bid" */ ? togglePopupCounter(item) :
                                            togglePopupSealedCounterBid(item)
                                        )} >
                                          {item.time == 0 || item.time === null ? "Counter Bid" : "Update Counter Bid"} </p>
                                      }
                                      </>}
                                  </div> : ""}

                                <div className='ntfc-mints'>
                                  {item?.notificationtime < 60 ? <h5>{item?.notificationtime} Minutes ago</h5> : item?.notificationtime > 1440 ? <h5>{Math.floor(item?.notificationtime / 1440)} days ago</h5> : item?.notificationtime > 43800 ? <h5>{Math.floor(item?.notificationtime / 43800)} months ago</h5> :
                                    <h5>{Math.floor(item?.notificationtime / 60)} Hours ago</h5>}
                                </div>

                              </div>
                              <div>
                              </div>
                              {allCarMultiAcceptEnable == true || allCarAcceptAllEnable == true ?
                                <div>

                                  {allCarMultiAcceptEnable &&
                                    <div className="custom_checkbox">
                                      <input type="checkbox" id={`allCarSelect${index}`} onClick={(e) => carSelectBox(`allCarSelect${index}`, item)} />
                                      <label for={`allCarSelect${index}`}></label>
                                    </div>
                                  }
                                  {allCarAcceptAllEnable &&
                                    <div className="custom_checkbox">
                                      <input type="checkbox" checked="true" id={`allCarSelected${index}`} />
                                      <label for={`allCarSelected${index}`}></label>
                                    </div>
                                  }
                                </div> :
                                <span class="notofication-close-icon" onClick={() => getDeleteNotification(item)}>
                                  <i class='bx bxs-x-circle'></i>
                                </span>}
                            </div>
                          </div>
                        </div>
                      </div>

) : <div>No Data Found</div>
}

                  </div>
               
                  
                }
                <div className='col-lg-12'>
                  {notificationInfo?.length > 0 &&
                    <div class="multiAccept notiMultiAccept">
                      {allCarMultiAcceptEnable == true ?
                        <span className="multiAcceptGrp">
                          <button onClick={() => MultiAcceptDisable()}> Cancel </button>
                          <button onClick={() => getDeleteAllNotification(dealerData)}> Ok </button> </span>
                        :
                        <button className="multiAcceptbtn" onClick={() => { setAllCarMultiAcceptEnable(true); setAllCarAcceptAllEnable(false) }}>Delete</button>}
                      {allCarAcceptAllEnable == true ?
                        <span className="acceptAllGrp"><button onClick={() => AllAcceptDisable()}> Cancel </button>
                          <button onClick={() => getDeleteAllNotification(dealerData)}> Ok </button> </span> :
                        <button className="acceptAll" onClick={(e) => allCarSelectBox(notificationInfo)}>SelectAll</button>
                      }
                    </div>
                  }
                  <button className='btn btn-danger margnleft' onClick={closePopup}>Close</button>


                </div>
                  


              </div>}

          </Modal.Body>

        </Modal>
      )}
      {isOpen1 &&
        <CommonPopup
          handleClose={togglePopup1}
          popupTitle={popupTitle}
          popupMsg={popupMsg}
          popupType={popupType}
          popupActionType={popupActionType}
          popupActionValue={popupActionValue}
          popupActionPath={popupActionPath}
        />
      }

      {isOpenAccept && <Popup
        isClose={false}
        content={<>
          <Accept toggle={togglePopupAccept} carId={carId} buyerId={buyerId} buyDealerId={buyDealerId} highBid={highBid} time={time} transportationCharge={transportationCharge} />
        </>}
        handleClose={togglePopupAccept}
      />}

      {isOpenCounter && <Popup
        isClose={false}
        content={<>
          <UrCarCounterBid toggle={togglePopupCounter} buyDealerId={buyDealerId} highBid={highBid} sellitNow={sellitNow} carId={carId} time={time} countBid={countBid} newBid={newBid} /* counterBitUpdateFlag={counterBitUpdateHandler} handleCounter={handleCounter} */ />
        </>}
        handleClose={togglePopupCounter}
      />}

      {isOpenSealedCounterBid && <Popup
        isClose={false}
        content={<>
          <SealedCounterBid toggle={togglePopupSealedCounterBid} buyDealerId={buyDealerId} highBid={highBid} sellitNow={sellitNow} countBid={countBid} newBid={newBid}  /* counterBitUpdateFlag={counterBitUpdateHandler} handleCounter={handleCounter} */ carId={carId} time={time} />
        </>}
        handleClose={togglePopupSealedCounterBid}
      />}

      {isOpenCarHistory && <Popup
        isClose={false}
        content={<>
          <SealedBid toggle={togglePopupCarHistory} carId={carId} buyerId={buyerId} highBid={highBid} sellerDealersId={sellerDealersId} sellitNow={sellitNow} transportationCharge={transportationCharge} /* isOpenCarHistory={isOpenCarHistory} */ />
        </>}
        handleClose={togglePopupCarHistory}
      />}
    </div>

  )
}
export default Header;